import { useSelector } from 'react-redux'

import LineCard from '../../../components/ReusableComponents/Charts/Inslghts/Line/index'
import MultiBarCard from '../../../components/ReusableComponents/Charts/Inslghts/MultiBar/index'
import Summary from '../../../components/ReusableComponents/Charts/Inslghts/Summary/index'
import styles from './ReclaimedGuests.module.scss'

const ReclaimedGuests = () => {
  const invitePerformances = useSelector(s => s.insights.invitePerformances)

  if (!invitePerformances) {
    return null
  }

  const { last12Months, summary } = invitePerformances

  return (
    <>
      <div className={styles.row}>
        <Summary {...summary} />
      </div>
      <div className={styles.row}>
        {last12Months && last12Months.length > 0 && (
          <div className={styles.reclaimedGuestsContainer}>
            <LineCard
              title="Reclaimed guests"
              subtitle="as total revenue"
              yLabel="revenue ($)"
              unit="$"
              data={last12Months.map(({ name, totalRate }) => ({
                name,
                revenue: totalRate
              }))}
            />
            <MultiBarCard
              title="Reclaimed guests"
              subtitle="as number of guests"
              yLabel="guests"
              barSize={8}
              data={last12Months.map(({ name, numberOfGuests }) => ({
                name,
                guests: numberOfGuests
              }))}
            />
          </div>
        )}
      </div>
    </>
  )
}
export default ReclaimedGuests
